// The three states a task can be in, as the footer offers them.
//
// The footer had two buttons that only moved forward — In Progress and
// Complete — so a task could not be put back to To do, and a completed one
// could not be reopened, except by dragging on the board's Status view,
// which the team rarely uses and which does not exist on a phone. One
// control, three states, any of them one tap away; the current one is
// marked, which the two buttons never said.
export type TaskStatusKey = 'todo' | 'inprogress' | 'completed';

export interface StatusChoice {
  key: TaskStatusKey;
  label: string;
  current: boolean;
  hint: string;
}

const KNOWN: TaskStatusKey[] = ['todo', 'inprogress', 'completed'];

export function statusChoices(status?: string | null): StatusChoice[] {
  const raw = String(status || '').toLowerCase();
  const current: TaskStatusKey = (KNOWN as string[]).includes(raw) ? (raw as TaskStatusKey) : 'todo';
  return [
    { key: 'todo', label: 'To do', current: current === 'todo', hint: 'Back to the To Do column — nobody is on it yet.' },
    { key: 'inprogress', label: 'In progress', current: current === 'inprogress', hint: 'Somebody is working on it. Nothing is sent to the patient.' },
    {
      key: 'completed',
      label: current === 'completed' ? 'Completed' : 'Complete',
      current: current === 'completed',
      hint: 'Closes this task and takes it off the board. Nothing is sent to the patient.',
    },
  ];
}
